import { render, staticRenderFns } from "./PriceTrend.vue?vue&type=template&id=aed15f78&"
import script from "./PriceTrend.vue?vue&type=script&lang=js&"
export * from "./PriceTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports